import { Component, OnDestroy, OnInit } from '@angular/core'
import { MatTableDataSource } from '@angular/material'
import { Subscription } from 'rxjs/Subscription'
import { fuseAnimations } from '../../../../core/animations'
import 'rxjs/add/operator/switchMap'
import 'rxjs/add/operator/do'
import 'rxjs/add/operator/map'
import { UserResponse } from '../../../models/user-response'

import { UserModel } from '../../../models/user.model'
import { FormControl } from '@angular/forms'
import { UserService } from '../../../services/user.service'

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss'],
  animations: fuseAnimations,
})
export class UserListComponent implements OnInit, OnDestroy {
  searchInput: FormControl
  usersResponse: UserResponse
  onFilterChanged: Subscription
  onUserChanged: Subscription
  onSearchChanged: Subscription
  displayedColumns = ['id', 'name', 'email', 'status', 'last_login']
  dataSource: any

  constructor(private userService: UserService) {
    this.searchInput = new FormControl(this.userService.getSearch())
  }

  ngOnInit() {
    this.onFilterChanged = this.userService.onUsersChanged.subscribe((response: UserResponse) => {
      this.usersResponse = response
      const userArray = []
      for (const item of response.items) {
        userArray.push(item)
      }
      this.dataSource = new MatTableDataSource<UserModel>(userArray)
    })

    this.onSearchChanged = this.searchInput.valueChanges
      .debounceTime(800)
      .distinctUntilChanged()
      .subscribe(searchText => {
        this.userService.changeSearch(searchText)
      })
  }

  ngOnDestroy() {
    this.onFilterChanged.unsubscribe()
    this.onSearchChanged.unsubscribe()
  }

  /**
   *
   * @param {UserModel} user
   */
  readUser(user: UserModel) {
    this.userService.setCurrentUser(user)
  }

  getServerData(event) {
    this.userService.changeFilter(event)
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/users/user-list/user-list.component.ts